import * as React from 'react'

import './styles/GridLines.css'

export class GridLines extends React.Component<any, any> {
    render() {
        return (
            <div className={`grid-lines ${(this.props.hidden) ? 'hidden' : ''}`} />
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/GridLines/GridLines.tsx